
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","fill":"#424242"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 10h22v22c0 2.2-1.8 4-4 4H13c-2.2 0-4-1.8-4-4V10zM8 7h24c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1zM17 4h6c.6 0 1 .4 1 1s-.4 1-1 1h-6c-.6 0-1-.4-1-1s.4-1 1-1z"}}),_c('path',{attrs:{"d":"M0 0h40v40H0V0z","fill":"none"}})])
          )
        }
      }
    